import moment from 'moment';

import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import { fromAnyDateToZuluDayEnd } from 'utils/converters/time/from.util';

import { upgradeStock } from 'stocks/utils';

export const STOCK_DATA_REQUEST = 'STOCK_DATA_REQUEST';
export const STOCK_DATA_SUCCESS = 'STOCK_DATA_SUCCESS';
export const STOCK_DATA_FAILURE = 'STOCK_DATA_FAILURE';
export const STOCK_COUNT_REQUEST = 'STOCK_COUNT_REQUEST';
export const STOCK_COUNT_SUCCESS = 'STOCK_COUNT_SUCCESS';
export const STOCK_COUNT_FAILURE = 'STOCK_COUNT_FAILURE';
export const EDIT_STOCK_REQUEST = 'EDIT_STOCK_REQUEST';
export const EDIT_STOCK_SUCCESS = 'EDIT_STOCK_SUCCESS';
export const EDIT_STOCK_FAILURE = 'EDIT_STOCK_FAILURE';
export const DELETE_STOCK_REQUEST = 'DELETE_STOCK_REQUEST';
export const DELETE_STOCK_SUCCESS = 'DELETE_STOCK_SUCCESS';
export const DELETE_STOCK_FAILURE = 'DELETE_STOCK_FAILURE';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';

export const QR_DATA_REQUEST = 'QR_DATA_REQUEST';
export const QR_DATA_SUCCESS = 'QR_DATA_SUCCESS';
export const QR_DATA_FAILURE = 'QR_DATA_FAILURE';

export const PUSH_MSG_UPDATE_STOCK = 'PUSH_MSG_UPDATE_STOCK';
export const SORT_DATA = 'SORT_DATA';
export const APPLY_FILTERS = 'APPLY_FILTER';
export const SET_FILTER_VALUE = 'SET_FILTER_VALUE';
export const CLEAR_FILTER = 'CLEAR_FILTER';

export const EDIT_MIN_STOCK_REQUEST = 'EDIT_MIN_STOCK_REQUEST';
export const EDIT_MIN_STOCK_SUCCESS = 'EDIT_MIN_STOCK_SUCCESS';
export const EDIT_MIN_STOCK_FAILURE = 'EDIT_MIN_STOCK_FAILURE';

export const EDIT_MAX_STOCK_REQUEST = 'EDIT_MAX_STOCK_REQUEST';
export const EDIT_MAX_STOCK_SUCCESS = 'EDIT_MAX_STOCK_SUCCESS';
export const EDIT_MAX_STOCK_FAILURE = 'EDIT_MAX_STOCK_FAILURE';

export const SELECT_ALL_ITEMS = 'SELECT_ALL_ITEMS';
export const SELECT_ITEM = 'SELECT_ITEM';
export const SELECT_ORDER_ITEM = 'SELECT_ORDER_ITEM';
export const TICK_SELECT_ALL = 'TICK_SELECT_ALL';

export const BULK_UPDATE_REQUEST = 'BULK_UPDATE_REQUEST';
export const BULK_UPDATE_SUCCESS = 'BULK_UPDATE_SUCCESS';
export const BULK_UPDATE_FAILURE = 'BULK_UPDATE_FAILURE';

export const ADD_TO_BASKET_ITEMS = 'ADD_TO_BASKET_ITEMS';
export const DELETE_ORDER_ITEM = 'DELETE_ORDER_ITEM';
export const EDIT_ORDER_ITEM = 'EDIT_ORDER_ITEM';

export const EMPTY_ORDER_BASKET_REQUEST = 'EMPTY_ORDER_BASKET_REQUEST';
export const EMPTY_ORDER_BASKET_SUCCESS = 'EMPTY_ORDER_BASKET_SUCCESS';
export const EMPTY_ORDER_BASKET_FAILURE = 'EMPTY_ORDER_BASKET_FAILURE';

export const SAVE_BASKET_REQUEST = 'SAVE_BASKET_REQUEST';
export const SAVE_BASKET_SUCCESS = 'SAVE_BASKET_SUCCESS';
export const SAVE_BASKET_FAILURE = 'SAVE_BASKET_FAILURE';

export const GET_BASKET_REQUEST = 'GET_BASKET_REQUEST';
export const GET_BASKET_SUCCESS = 'GET_BASKET_SUCCESS';
export const GET_BASKET_FAILURE = 'GET_BASKET_FAILURE';

export const LOAD_BRANDS_REQUEST = 'LOAD_BRANDS_REQUEST';
export const LOAD_BRANDS_SUCCESS = 'LOAD_BRANDS_SUCCESS';
export const LOAD_BRANDS_FAILURE = 'LOAD_BRANDS_FAILURE';

export const LOAD_SUB_BRANDS_REQUEST = 'LOAD_SUB_BRANDS_REQUEST';
export const LOAD_SUB_BRANDS_SUCCESS = 'LOAD_SUB_BRANDS_SUCCESS';
export const LOAD_SUB_BRANDS_FAILURE = 'LOAD_SUB_BRANDS_FAILURE';

export const GENERATE_STOCK_ORDER_REQUEST = 'GENERATE_STOCK_ORDER_REQUEST';
export const GENERATE_STOCK_ORDER_SUCCESS = 'GENERATE_STOCK_ORDER_SUCCESS';
export const GENERATE_STOCK_ORDER_FAILURE = 'GENERATE_STOCK_ORDER_FAILURE';

export const LAST_STOCK_ORDER_SUCCESS = 'LAST_STOCK_ORDER_SUCCESS';
export const LAST_STOCK_ORDER_REQUEST = 'LAST_STOCK_ORDER_REQUEST';
export const LAST_STOCK_ORDER_FAILURE = 'LAST_STOCK_ORDER_FAILURE';

export const SELECT_ALL_ORDER_ITEMS = 'SELECT_ALL_ORDER_ITEMS';
export const TICK_ORDER_SELECT_ALL = 'TICK_ORDER_SELECT_ALL';
export const UPDATE_COST_PRICE = 'UPDATE_COST_PRICE';
export const UPDATE_RETAIL_PRICE = 'UPDATE_RETAIL_PRICE';
export const REVERT_COST_RETAIL_PRICE = 'REVERT_COST_RETAIL_PRICE';

export const LOAD_ORDER_LIST_REQUEST = 'LOAD_ORDER_LIST_REQUEST';
export const LOAD_ORDER_LIST_SUCCESS = 'LOAD_ORDER_LIST_SUCCESS';
export const LOAD_ORDER_LIST_FAILURE = 'LOAD_ORDER_LIST_FAILURE';

export const SCAN_ORDER_REQUEST = 'SCAN_ORDER_REQUEST';
export const SCAN_ORDER_SUCCESS = 'SCAN_ORDER_SUCCESS';
export const SCAN_ORDER_FAILURE = 'SCAN_ORDER_FAILURE';

export const DELETE_ORDER_REQUEST = 'DELETE_ORDER_REQUEST';
export const DELETE_ORDER_SUCCESS = 'DELETE_ORDER_SUCCESS';
export const DELETE_ORDER_FAILURE = 'DELETE_ORDER_FAILURE';

export const IMPORT_BULK_ORDER_REQUEST = 'IMPORT_BULK_ORDER_REQUEST';
export const IMPORT_BULK_ORDER_SUCCESS = 'IMPORT_BULK_ORDER_SUCCESS';
export const IMPORT_BULK_ORDER_FAILURE = 'IMPORT_BULK_ORDER_FAILURE';

export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST';
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS';
export const ORDER_DETAILS_FAILURE = 'ORDER_DETAILS_FAILURE';

export const LOAD_CATEGORIES_REQUEST = 'LOAD_CATEGORIES_REQUEST';
export const LOAD_CATEGORIES_SUCCESS = 'LOAD_CATEGORIES_SUCCESS';
export const LOAD_CATEGORIES_FAILURE = 'LOAD_CATEGORIES_FAILURE';

export function getStockData(salonId) {
  const endpoint = `product/salon/${salonId}/`;
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [STOCK_DATA_REQUEST, STOCK_DATA_SUCCESS, STOCK_DATA_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  };
}

export function getStockCount(salonId, startDate, endDate) {
  const bgn = moment(startDate).toISOString();
  const end = fromAnyDateToZuluDayEnd(endDate);

  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint: `product/salon/${salonId}/count/${bgn}/${end}/`,
      authenticated: true,
      types: [STOCK_COUNT_REQUEST, STOCK_COUNT_SUCCESS, STOCK_COUNT_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  };
}

export function editStock(salonId, stock, editFilters) {
  const endpoint = `product/salon/${salonId}/product/${stock.id}/`;
  const editedElement = upgradeStock({ ...stock });
  const editablePart = {
    title: editedElement.title,
    brand: editedElement.brand,
    sub_brand: editedElement.sub_brand,
    category: editedElement.category_name,
    quantity: editedElement.units_in_stock,
    cost_price: editedElement.cost_price,
    price: editedElement.price,
  };
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [EDIT_STOCK_REQUEST, EDIT_STOCK_SUCCESS, EDIT_STOCK_FAILURE],
      config: {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(editablePart),
      },
      params: { editedElement, editFilters },
    },
  };
}

export function editStockMinHolding(salonId, stock, amount) {
  const endpoint = `product/salon/${salonId}/product/${stock.id}/min/`;
  const editablePart = {
    min_in_stock: amount,
  };
  const editedElement = stock;
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [EDIT_MIN_STOCK_REQUEST, EDIT_MIN_STOCK_SUCCESS, EDIT_MIN_STOCK_FAILURE],
      config: {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(editablePart),
      },
      params: { editedElement },
    },
  };
}

export function editStockMaxHolding(salonId, stock, amount) {
  const endpoint = `product/salon/${salonId}/product/${stock.id}/max/`;
  const editablePart = {
    max_in_stock: amount,
  };
  const editedElement = stock;
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [EDIT_MAX_STOCK_REQUEST, EDIT_MAX_STOCK_SUCCESS, EDIT_MAX_STOCK_FAILURE],
      config: {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(editablePart),
      },
      params: { editedElement },
    },
  };
}

export function loadBrands(salonId) {
  const endpoint = `product/salon/${salonId}/brands/`;
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [LOAD_BRANDS_REQUEST, LOAD_BRANDS_SUCCESS, LOAD_BRANDS_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  };
}

export function loadSubBrands(salonId) {
  const endpoint = `product/salon/${salonId}/subbrands/`;
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [LOAD_SUB_BRANDS_REQUEST, LOAD_SUB_BRANDS_SUCCESS, LOAD_SUB_BRANDS_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  };
}

export function loadCategories(salonId) {
  const endpoint = `product/salon/${salonId}/categories/`;
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [LOAD_CATEGORIES_REQUEST, LOAD_CATEGORIES_SUCCESS, LOAD_CATEGORIES_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  };
}

export const deleteProduct = (productId) => {
  const config = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint: `product/${productId}/`,
      authenticated: true,
      types: [DELETE_STOCK_REQUEST, DELETE_STOCK_SUCCESS, DELETE_STOCK_FAILURE],
      config,
      params: {
        productId,
      },
    },
  };
};

export function getQRData() {
  const endpoint = 'authentication/onetimetoken/';
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint,
      authenticated: true,
      types: [QR_DATA_REQUEST, QR_DATA_SUCCESS, QR_DATA_FAILURE],
      config: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: '{}',
      },
    },
  };
}

export function toggleFilter(filter, valueToToggle) {
  return {
    type: TOGGLE_FILTER,
    filter,
    valueToToggle,
  };
}

export function toggleFilterValue(filter, valueToToggle, setValue) {
  return {
    type: SET_FILTER_VALUE,
    filter,
    valueToToggle,
    setValue,
  };
}

export function applyFilters() {
  return {
    type: APPLY_FILTERS,
  };
}

export function sortData(sortItemData) {
  const sortOption = sortItemData;
  return {
    type: SORT_DATA,
    sortOption,
  };
}

export function clearFilter() {
  return {
    type: CLEAR_FILTER,
  };
}

export function toogleCheckAll(isChecked) {
  return {
    type: SELECT_ALL_ITEMS,
    isChecked,
  };
}

export function toggleSelectItem(selectStock, select) {
  const updateItem = selectStock;
  updateItem.selected = select;
  return {
    type: SELECT_ITEM,
    updateItem,
  };
}

export function tickSelectAll(setSelectAll, isFromOrder) {
  if (isFromOrder) {
    return {
      type: TICK_ORDER_SELECT_ALL,
      setSelectAll,
    };
  }
  return {
    type: TICK_SELECT_ALL,
    setSelectAll,
  };
}

export function toggleAllOrderItem(setSelectAll) {
  return {
    type: SELECT_ALL_ORDER_ITEMS,
    setSelectAll,
  };
}

export function toggleOrderItem(selectStock, select) {
  const updateItem = selectStock;
  updateItem.selected = select;
  return {
    type: SELECT_ORDER_ITEM,
    updateItem,
  };
}

export function doBulkUpdate(salonId, newBrand, newSubBrand, newCategory, products) {
  const endpoint = `product/salon/${salonId}/product/bulkupdate/`;
  const updateListData = [];
  products.forEach((n) => {
    const item = {
      id: n.id,
      brand_name: newBrand,
      sub_brand_name: newSubBrand,
      category_name: newCategory,
      cost_price: n.cost_price ? parseFloat(n.cost_price) : '',
      retail_price: n.price,
    };
    updateListData.push(item);
  });
  const data = updateListData;
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [BULK_UPDATE_REQUEST, BULK_UPDATE_SUCCESS, BULK_UPDATE_FAILURE],
      config: {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      },
      params: { data },
    },
  };
}

export function bulkUpdate(salonId, newBrand, newSubBrand, newCategory, products) {
  return (dispatch) => {
    dispatch(doBulkUpdate(salonId, newBrand, newSubBrand, newCategory, products)).then(() => {
      if (newBrand) {
        dispatch(loadBrands(salonId));
      }
      if (newSubBrand) {
        dispatch(loadSubBrands(salonId));
      }
      if (newCategory) {
        dispatch(loadCategories(salonId));
      }
    });
  };
}

export function addItemsToBasket() {
  return {
    type: ADD_TO_BASKET_ITEMS,
  };
}

export function deleteOrderItem(orderItem) {
  return {
    type: DELETE_ORDER_ITEM,
    orderItem,
  };
}

export function emptyOrderBasket(salonId) {
  const updateList = {
    products: [],
  };
  const endpoint = `order/salon/${salonId}/basket/`;
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [EMPTY_ORDER_BASKET_REQUEST, EMPTY_ORDER_BASKET_SUCCESS, EMPTY_ORDER_BASKET_FAILURE],
      config: {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateList),
      },
    },
  };
}

export function editOrderItem(orderItem) {
  return {
    type: EDIT_ORDER_ITEM,
    orderItem,
  };
}

export function saveBasket(salonId, orderList) {
  const endpoint = `order/salon/${salonId}/basket/`;
  const updateList = {
    products: orderList,
  };
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [SAVE_BASKET_REQUEST, SAVE_BASKET_SUCCESS, SAVE_BASKET_FAILURE],
      config: {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateList),
      },
    },
  };
}

export function getSavedBasket(salonId) {
  const endpoint = `order/salon/${salonId}/basket/`;
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [GET_BASKET_REQUEST, GET_BASKET_SUCCESS, GET_BASKET_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  };
}

export function onGenerateOrderData(salonId) {
  const endpoint = `order/salon/${salonId}/generate/`;
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [GENERATE_STOCK_ORDER_REQUEST, GENERATE_STOCK_ORDER_SUCCESS, GENERATE_STOCK_ORDER_FAILURE],
      config: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  };
}

export function generateOrderData(salonId, orderList) {
  return (dispatch) => {
    dispatch(saveBasket(salonId, orderList)).then(() => {
      dispatch(onGenerateOrderData(salonId));
    });
  };
}

export function getLastOrderData(salonId, isBtnClicked) {
  const endpoint = `order/salon/${salonId}/latest/`;
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [LAST_STOCK_ORDER_REQUEST, LAST_STOCK_ORDER_SUCCESS, LAST_STOCK_ORDER_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: { isBtnClicked },
    },
  };
}

export function applyCostPriceChange(newCost, incrCost, percent) {
  return {
    type: UPDATE_COST_PRICE,
    newCost,
    incrCost,
    percent,
  };
}

export function applyRetailPriceChange(newRetail, incrRetail, percent, roundOption) {
  return {
    type: UPDATE_RETAIL_PRICE,
    newRetail,
    incrRetail,
    percent,
    roundOption,
  };
}

export function revertCostorRetailPrice() {
  return {
    type: REVERT_COST_RETAIL_PRICE,
  };
}

export function loadOrderList(salonId) {
  const endpoint = `order/salon/${salonId}/list/`;
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [LOAD_ORDER_LIST_REQUEST, LOAD_ORDER_LIST_SUCCESS, LOAD_ORDER_LIST_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  };
}

export function scanOrder(salonId, orderId) {
  const endpoint = `order/salon/${salonId}/scan/${orderId}/`;
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [SCAN_ORDER_REQUEST, SCAN_ORDER_SUCCESS, SCAN_ORDER_FAILURE],
      config: {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: { orderId },
    },
  };
}

export function deleteOrder(salonId, orderId) {
  const endpoint = `order/salon/${salonId}/delete/${orderId}/`;
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [DELETE_ORDER_REQUEST, DELETE_ORDER_SUCCESS, DELETE_ORDER_FAILURE],
      config: {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: { orderId },
    },
  };
}

export function doImportBulkOrder(salonId, orderId, orderList) {
  const endpoint = `order/salon/${salonId}/import/${orderId}/`;
  const updateList = [];
  orderList.forEach((order) => {
    const orderItem = {
      product_id: order.product.id,
      quantity_change: order.quantity_update || order.quantity_update === 0 ? order.quantity_update : order.quantity,
    };
    updateList.push(orderItem);
  });
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [IMPORT_BULK_ORDER_REQUEST, IMPORT_BULK_ORDER_SUCCESS, IMPORT_BULK_ORDER_FAILURE],
      config: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateList),
      },
      params: { orderId },
    },
  };
}

export function importBulkOrder(salonId, orderId, orderList) {
  return (dispatch) => {
    dispatch(doImportBulkOrder(salonId, orderId, orderList)).then(() => {
      dispatch(loadOrderList(salonId));
    });
  };
}

export function getOrderDetails(salonId, orderId) {
  const endpoint = `order/salon/${salonId}/details/${orderId}/`;
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint,
      authenticated: true,
      types: [ORDER_DETAILS_REQUEST, ORDER_DETAILS_SUCCESS, ORDER_DETAILS_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: { orderId },
    },
  };
}
